import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
  version: {
    position: 'fixed',
    bottom:0,
    right:0,
    zIndex: 9999,
    color: "rgba(0,0,0,0.2)",
    pointerEvents: "none",
    fontWeight: 700,
  }
}));
const Versioning = ({}) => {
  const classes = useStyles()
  return <div className={classes.version}>
    {process.env.VERSION} {process.env.COMMIT_HASH}
  </div>
}

export {Versioning}